import { Calendar, Clock, MapPin, Users, Gauge, Tag, ExternalLink } from "lucide-react";
import { track, EVENT } from "@/lib/track";

const fmtDate = (d) => {
  if (!d) return null;
  try { return new Date(d).toLocaleDateString(undefined, { weekday: "short", month: "short", day: "numeric" }); } catch { return null; }
};

export const EventCard = ({ item }) => {
  const date = fmtDate(item.event_date);
  const metas = [
    item.age_group && { icon: Users, text: item.age_group },
    item.skill_level && item.skill_level !== "N/A" && { icon: Gauge, text: item.skill_level },
    item.price && { icon: Tag, text: item.price },
    item.capacity && { icon: Users, text: item.capacity },
  ].filter(Boolean);

  return (
    <div data-testid="event-card" className="group flex flex-col overflow-hidden rounded-xl border border-border bg-card transition-colors duration-200 hover:border-[hsl(var(--brand-red))]">
      {item.image_url && (
        <div className="relative h-44 overflow-hidden">
          <img src={item.image_url} alt={item.title} loading="lazy" className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105" />
          <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent" />
          {item.event_type && (
            <span className="absolute left-3 top-3 rounded-md bg-brand px-2.5 py-1 text-xs font-bold uppercase tracking-wide text-white" data-testid="event-type-badge">{item.event_type}</span>
          )}
        </div>
      )}

      <div className="flex flex-1 flex-col p-6">
        <h3 className="display-title text-2xl leading-tight">{item.title}</h3>

        <div className="mt-3 grid gap-1.5 text-sm">
          {date && <span className="flex items-center gap-2 text-foreground"><Calendar className="h-4 w-4 text-brand" />{date}</span>}
          {item.event_time && <span className="flex items-center gap-2 text-muted-foreground"><Clock className="h-4 w-4 text-brand" />{item.event_time}</span>}
          {item.location && <span className="flex items-center gap-2 text-muted-foreground"><MapPin className="h-4 w-4 text-brand" />{item.location}</span>}
        </div>

        {item.description && <p className="mt-3 text-sm text-muted-foreground">{item.description}</p>}

        {metas.length > 0 && (
          <div className="mt-4 flex flex-wrap gap-2">
            {metas.map((m) => {
              const Icon = m.icon;
              return <span key={m.text} className="inline-flex items-center gap-1.5 rounded-full bg-muted px-3 py-1 text-xs font-medium text-muted-foreground"><Icon className="h-3.5 w-3.5 text-brand" />{m.text}</span>;
            })}
          </div>
        )}

        <div className="flex-1" />

        {item.cta_url && (
          <a href={item.cta_url} target="_blank" rel="noopener noreferrer" data-testid="event-register-btn" onClick={() => track(EVENT.EVENT_REGISTRATION_CLICK, item.title)} className="mt-5 inline-flex w-full items-center justify-center gap-2 rounded-md bg-brand px-4 py-3 text-sm font-semibold uppercase tracking-wide text-white transition-colors duration-200 hover:bg-[hsl(var(--brand-red-deep))] active:scale-[0.98]">
            {item.cta_label || "Register"} <ExternalLink className="h-4 w-4" />
          </a>
        )}
      </div>
    </div>
  );
};
